import { ConcreteEncodable } from "./ConcreteEncodable";

import { SessionMetadataImplEncoder } from "../../encoder/SessionMetadataImplEncoder";

import * as CubiqTS from "../../index";
import { SessionMetadata } from "../SessionMetadata";

export class SessionMetadataImpl extends ConcreteEncodable implements SessionMetadata {
  public static enType: string = "com.bcdfx.broker.SessionMetadataImpl";

  /*FID=1*/
  public connectionSessionId: string;
  /*FID=2*/
  public proxyConnectionId: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SessionMetadataImplEncoder.Instance;
    this.setEncodableType(SessionMetadataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SessionMetadataImpl[" +
      "connectionSessionId=" +
      this.connectionSessionId +
      "proxyConnectionId=" +
      this.proxyConnectionId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
